<template>
  <div class="ml-1 mt-2 p-2 border border-gray-200 rounded bg-gray-50 inline-block text-left">

    <small class="text-gray-400">
      <label class="font-medium">
        EVENTO:
      </label>
      <label class="text-gray-600 text-base font-bold uppercase">
        {{
          item.title?.length > 20
          ? item.title.slice(0, 20).concat("...")
          : item.title
        }}
      </label>
    </small>

    <br>

    <small class="text-gray-400">
      <label class="font-medium">
        DATA:
      </label>
      <label class="text-gray-500 text-base font-bold">
        {{
          formatDateHour(item?.starts_at)
        }}
      </label>
    </small>
  </div>

  <!-- <button
    class="flex items-center justify-center bg-red-500 text-white p-2 rounded-full -ml-4 -mt-1 h-5 w-5 "
    @click="removeItem"
  >
    <i class="fas fa-times"></i>
  </button> -->
</template>

<script>
import { formatDateHour } from '@/utils/formaters'

export default {
  props: {
    item: Object
  },
  data () {
    return {
      formatDateHour
    }
  },
  methods: {
    removeItem () {
      this.$emit('removeItem')
    },
    updateAmount () {
      this.$emit('updateItem', this.item) // Emite o item atualizado para o componente pai
    }
  },
  emits: ['removeItem', 'updateItem']
}
</script>
